import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {},
    template: `
        <ul class="actions01">
            <li class="primary">
                <a class="btn main" ng-click="vm.addSkillScale()">{{ "skill.Add scale" | translate }}</a>
            </li>
        </ul>

        <list-factory-empty list="{ items: vm.scales, loading: vm.loading }"></list-factory-empty>

        <div class="block02" ng-repeat="scale in vm.scales" ng-class="{ open: vm.openIndex===$index }">
            <div class="heading01 theme01">
                <h3 ng-click="vm.toggle($index)">
                    {{ (scale.activeI18n && scale.activeI18n.name) || ('Scale #' + scale.id) }}
                </h3>
                <action-menu button-label="Actions">
                    <li><a ng-click="vm.editScale(scale.id)">{{ 'general.Edit' | translate }}</a></li>
                    <li><a ng-click="vm.removeScale(scale.id)">{{ 'general.Delete' | translate }}</a></li>
                </action-menu>
            </div>
            <div class="block02b" ng-if="vm.openIndex===$index">
                <div class="mt2em">
                    <p ng-repeat="p in vm.getFilteredProficiencies(scale)" style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ vm.getProficiencyLabel(p, scale, $index) }}
                    </p>
                    <p ng-if="!vm.getFilteredProficiencies(scale).length">No levels</p>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor (lodash, DATATABLES, $uibModal, $rootScope, ModalService, SkillScaleResource, TokenService,
                 toastr, $translate) {
        this.lodash = lodash;
        this.dt = DATATABLES;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.ModalService = ModalService;
        this.skillScaleResource = SkillScaleResource;
        this.TokenService = TokenService;
        this.toastr = toastr;
        this.$translate = $translate;
        this.languageData = {};
    }

    getFilteredProficiencies (scale) {
        if (!scale || !scale.proficiencies) {
            return [];
        }
        const lang = scale.activeI18n && scale.activeI18n.language;
        if (!lang) {
            return [];
        }
        return scale.proficiencies.filter(p => {
            return p && p.skillProficiencyI18n && p.skillProficiencyI18n[lang] && p.skillProficiencyI18n[lang].value;
        });
    }

    getProficiencyLabel (p, scale, i) {
        const lang = scale && scale.activeI18n && scale.activeI18n.language;
        let value = '';
        if (p && p.skillProficiencyI18n && p.skillProficiencyI18n[lang] && p.skillProficiencyI18n[lang].value) {
            value = p.skillProficiencyI18n[lang].value;
        }
        if (value === '') {
            return null;
        }
        const index = (typeof i === 'number' ? i : 0) + 1;
        return `${index}. ${value || ''}`;
    }

    $onInit () {
        this.tableOptions = this.lodash.merge({}, this.dt, {
            info: false,
            ordering: true,
            paging: false
        });
        this.companyLanguage = this.TokenService.getCompanyLanguage && this.TokenService.getCompanyLanguage();
        this.scales = [];
        this.loading = false;
        this.refresh();
    }

    refresh () {
        this.loading = true;
        const params = { expand: 'activeI18n,proficiencies.skillProficiencyI18n' };
        const promise = this.skillScaleResource.query(params).$promise;
        promise.then((res) => {
            this.scales = Array.isArray(res) ? res : [];
            this.loading = false;
        }).catch(() => {
            this.loading = false;
            this.toastr.error(this.$translate.instant('skill.Failed to load skill scales'));
        });
    }

    toggle (idx) {
        this.openIndex = (this.openIndex === idx) ? null : idx;
    }

    addSkillScale () {
        return this.ModalService.open({
            template: `
                <modals-user-skills-scale-add
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                ></modals-user-skills-scale-add>
            `,
            size: 'large',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => {
            this.refresh();
        });
    }

    removeScale (scaleId) {
        const message = this.$translate.instant('skill.Confirm scale deletion');
        this.ModalService.confirm(message, 'medium')
            .then(() => {
                const promise = this.skillScaleResource.delete({ id: scaleId }).$promise;
                promise.then(() => {
                    this.toastr.success(this.$translate.instant('skill.Skill scale deleted'));
                    this.refresh();
                }).catch((err) => {
                    if (err && err.data[0].message) {
                        this.toastr.error(this.$translate.instant(err.data[0].message));
                    }
                    else {
                        this.toastr.error(this.$translate.instant('skill.Failed to delete skill scale'));
                    }
                });
            });
    }

    editScale (scaleId) {
        const params = {
            id: scaleId,
            expand: 'scaleI18ns,proficiencies.skillProficiencyI18n,skills.activeI18n,planningGroups'
        };

        // Fetch the full scale object
        const scalePromise = this.skillScaleResource.get(params).$promise
            .then(response => Array.isArray(response) ? response.find(s => s.id === scaleId) : response);

        // Build languageData dynamically from the resolved scale
        const languageDataPromise = scalePromise.then(scale => {
            const data = {};
            if (!scale) return data;
            Object.keys(scale.scaleI18ns || {}).forEach(lang => {
                const i18n = scale.scaleI18ns[lang] || {};
                data[lang] = {
                    name: (i18n.name) ? i18n.name : '',
                    enabled: (i18n.isEnabled !== undefined) ? !!i18n.isEnabled : true,
                    values: []
                };
            });
            return data;
        });

        // Open modal after resolves and inject resolved values into modal controller
        return this.ModalService.open({
            template: `
                <modals-user-skills-scale-edit
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    language-data="vm.languageData"
                    scale="vm.scale"
                ></modals-user-skills-scale-edit>
            `,
            size: 'large',
            resolve: {
                scale: () => scalePromise,
                languageData: () => languageDataPromise
            },
            controller: ['$uibModalInstance', 'scale', 'languageData', function ($uibModalInstance, scale, languageData) {
                this.$uibModalInstance = $uibModalInstance;
                this.scale = scale;
                this.languageData = languageData;
            }],
            controllerAs: 'vm'
        }).then(() => {
            this.refresh();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/skill/list/scale/index.js